import { EquipmentBrands } from '../enums';

export * from './napco';

export const n2pTheir911 = '10001000911';
export const n2pOur911 = '911';

export const inhandMetricsQueryParams =
  'modem_info&_wan1_modem_status&_cur_sim&_wan1_network_type&_wan1_siglevel&_wan1_rsrp&_wan1_rsrq&_wan1_imei&_wan1_imsi&_wan1_iccid&_wan1_plmn&_wan1_band&_wan1_lac&_wan1_cellid&_wan1_used_apn&wan0_ip&_mqtt_status&_wan0_get_ip';

export const LAN_MAC_BRANDS = [EquipmentBrands.INHAND, EquipmentBrands.PEPWAVE];
export const WAN_MAC_BRANDS = [
  EquipmentBrands.CRADLEPOINT,
  EquipmentBrands.ERICSSON,
  EquipmentBrands.MOFI,
];

export const ethernetWan = 'ethernet-wan';
